import * as React from 'react'
import FeatureEditor from '../../core/components/FeatureViews/FeatureEditor'
import {Feature, FeatureStatus} from '../../core/models'
import {ISourceApplyEdits} from '../../core/interfaces/services'
import {ServiceHub} from '../../core/ServiceHub'
import appConfig from '../../reducers/appConfig'
import {LocationSelector} from '../App/LocationSelector'
import {IFeatureLayerInfo} from '../../core/interfaces/models'

class AppFeatureEditor extends FeatureEditor {
  protected delete(feature: Feature): void {
    if (appConfig.reg.regrelated.indexOf(this.props.layerInfo.url) != -1) {
      this.setState({...this.state, loading: true, errorMessage: ''})
      let promise: Promise<ISourceApplyEdits[]>
      const paylod: ISourceApplyEdits[] = [{layerInfo: this.props.layerInfo, adds: [], updates: [feature], deletes: []}]
      if (this.props.editsDispatcher) {
        promise = new Promise((resolve, reject) => {
          this.props.editsDispatcher!.applyEdits(
            paylod,
            edits => {
              resolve(edits)
            },
            e => {
              reject(e)
              this.onError(e)
            }
          )
        })
      } else {
        promise = ServiceHub.gisCrudService.applyEdits(paylod)
      }
      promise
        .then(result => {
          this.props.layerInfo.refresh()
          this.setState({...this.state, loading: false})
          if (this.props.onAfterDelete) {
            this.props.onAfterDelete(feature)
          }
        })
        .catch(error => {
          this.onError(error)
        })
    } else {
      super.delete(feature)
    }
  }
  protected onError(error: any) {
    if (error && error.response && error.response.data && error.response.data.indexOf('Dublicate parcels') != -1) {
      this.setState({
        ...this.state,
        loading: false,
        errorMessage: `В квартала има парцели с повтарящи се номера ${
          error.response.data.split(':')[2]
        }. Моля първо оправете грешките`
      })
    } else if (error && error.response && error.response.data) {
      this.setState({...this.state, loading: false, errorMessage: error.response.data})
    } else {
      this.setState({...this.state, loading: false, errorMessage: 'Възникна грешка'})
    }
  }
  protected isSaveDisabled(feature: Feature): boolean {
    return (
      (appConfig.reg.regrelated.indexOf(this.props.layerInfo.url) != -1 &&
        ((feature.status == FeatureStatus.New && !this.props.feature.getProperties()['_LOCATION']) ||
          feature.getGeometry() == null)) ||
      (appConfig.ISettlementRelated.indexOf(this.props.layerInfo.sourceDescription.id) != -1 &&
        ((feature.status == FeatureStatus.New && !this.props.feature.getProperties()['SettlementId']) ||
          feature.getGeometry() == null)) ||
      (appConfig.misc.miscrelated.indexOf(this.props.layerInfo.url) != -1 &&
        ((feature.status == FeatureStatus.New && !this.props.feature.getProperties()['_LOCATION']) ||
          feature.getGeometry() == null))
    )
  }

  protected renderEditingBody(feature: Feature, layerInfo: IFeatureLayerInfo): JSX.Element {
    if (
      appConfig.reg.regrelated.indexOf(this.props.layerInfo.url) != -1 ||
      appConfig.misc.miscrelated.indexOf(this.props.layerInfo.url) != -1
    ) {
      return (
        <React.Fragment>
          {feature.status == FeatureStatus.New ? (
            <LocationSelector
              onSettlementsChange={(locs, sett, loc) => {
                this.props.feature.set('_SETTLEMENT', sett)
                this.props.feature.set('_LOCATION', loc)
                if (loc) {
                  this.props.feature.set('RegPlanId', loc.getProperties()['Id'])
                  this.props.feature.set('LocalityId', loc.getProperties()['Id'])
                } else {
                  this.props.feature.set('LocalityId', undefined)
                  this.props.feature.set('RegPlanId', undefined)
                }
                this.applyChanges(this.props.feature)
              }}
              selectedSettlemet={this.props.feature.getProperties()['_SETTLEMENT']}
              selectedLocation={this.props.feature.getProperties()['_LOCATION']}
            />
          ) : null}
          {this.sortFields(this.renderFeatures(feature, layerInfo), layerInfo)}
        </React.Fragment>
      )
    } else if (appConfig.ISettlementRelated.indexOf(this.props.layerInfo.url) != -1) {
      return (
        <React.Fragment>
          {feature.status == FeatureStatus.New ? (
            <LocationSelector
              hideLocations={true}
              onSettlementsChange={(locs, sett, loc) => {
                this.props.feature.set('_SETTLEMENT', sett)
                this.props.feature.set('SettlementId', sett ? sett.get('EKATTE') : undefined)
                this.applyChanges(this.props.feature)
              }}
              selectedSettlemet={this.props.feature.getProperties()['_SETTLEMENT']}
            />
          ) : null}
          {this.sortFields(this.renderFeatures(feature, layerInfo), layerInfo)}
        </React.Fragment>
      )
    }
    return <React.Fragment>{this.sortFields(this.renderFeatures(feature, layerInfo), layerInfo)}</React.Fragment>
  }
}

export default AppFeatureEditor
